import React from 'react';

import i18n from '../../i18n';

// @mui
import { Box, TextField, Typography } from '@mui/material';

export default class DialogTextField extends React.Component {
    render() {
        // field, value, cache, onChange
        let show = this.props.field.show;
        let value = this.props.value?.[show] || this.props.value;
        let translatedName = i18n.t(`columns.${this.props.field.label}`);
        const onlyRead = !!this.props.field.onlyRead;

        if (onlyRead) {
            // Render as a Typography component if onlyRead is true
            // Show the translated name and value
            return (
                <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="body2" color="textSecondary">
                        {translatedName}:
                    </Typography>
                    {value ? (
                        <Typography variant="body1" color="textPrimary">
                            {value}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            {i18n.t('common.notSet')}
                        </Typography>
                    )}
                </Box>
            );
        }

        return (
            <TextField
                key={this.props.field.id}
                // Focus is assigned by DialogAbstract to the first field. Three
                // components used to request it themselves, so which one won came
                // down to mount order.
                autoFocus={this.props.autoFocus}
                id={this.props.field.id}
                label={translatedName}
                type="text"
                required={Boolean(this.props.field.required)}
                error={Boolean(this.props.error)}
                helperText={this.props.error || ''}
                value={value || ''}
                fullWidth
                onBlur={this.props.onBlur}
                onChange={(event) =>
                    this.props.onChange(event.target.id, event.target.value)
                }
            />
        );
    }
}
